import {
  Button,
  Inline,
  Modal,
  type ModalProps,
} from '@omnipresentgroup/design-system';
import { Form } from '@omnipresentgroup/flexible-forms';
import type { IChangeEvent } from '@rjsf/core';
import { useState } from 'react';

type Props = {
  modalProps: Omit<ModalProps, 'children'>;
  handleSubmit: (data: FormFields) => void;
  handleCancel: () => void;
};

const MODAL_TITLE = 'Request timesheet changes';
const FORM_ID = 'timesheet-request-changes-form';

type FormFields = {
  reason: string;
};

export const TimesheetRequestChangesModal = (props: Props) => {
  const { modalProps, handleCancel, handleSubmit } = props;

  const [formValues, setFormValues] = useState<FormFields>();

  // Form Change
  const onChange = ({ formData }: IChangeEvent<FormFields>) => {
    setFormValues(formData);
  };

  // Form Submit
  const onSubmit = () => {
    if (formValues) {
      handleSubmit(formValues);
    }
  };

  return (
    <Modal {...modalProps} span={3}>
      <Modal.Header title={MODAL_TITLE} />
      <Modal.Body>
        <Form<FormFields>
          id={FORM_ID}
          schema={{
            type: 'object',
            required: ['reason'],
            properties: {
              reason: {
                type: 'string',
                title: 'Reason',
              },
            },
          }}
          uiSchema={{
            'ui:submitButtonOptions': {
              norender: true,
            },
            reason: {
              'ui:widget': 'textarea',
            },
          }}
          formData={formValues}
          onChange={onChange}
          onSubmit={onSubmit}
        />
      </Modal.Body>
      <Modal.Footer>
        <Inline justify="space-between" w="stretch">
          <Button variant="secondary" onClick={handleCancel}>
            Cancel
          </Button>
          <Button type="submit" form={FORM_ID}>
            Submit
          </Button>
        </Inline>
      </Modal.Footer>
    </Modal>
  );
};
